var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPStoreprofileFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5072 36C21.2482 36 22.6727 34.5231 22.6727 32.7179H16.3418C16.3418 33.5884 16.6753 34.4232 17.2689 35.0387C17.8626 35.6542 18.6677 36 19.5072 36ZM29.0035 26.1538V17.9487C29.0035 12.9108 26.4079 8.69333 21.8813 7.57744V6.46154C21.8813 5.09949 20.8209 4 19.5072 4C18.1936 4 17.1332 5.09949 17.1332 6.46154V7.57744C12.5908 8.69333 10.0109 12.8944 10.0109 17.9487V26.1538L7.96924 28.2708C6.97213 29.3046 7.66852 31.0769 9.07714 31.0769H29.9215C31.3301 31.0769 32.0423 29.3046 31.0452 28.2708L29.0035 26.1538Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPStoreprofileFollow);
export default __webpack_public_path__ + "static/media/p_storeprofile_follow.f8e00b3d001178e685dd550f1fe7fc35.svg";
export { ForwardRef as ReactComponent };